export enum ECallEventName {
    MEDIA_STATE = "mediaState",
    STATE = "state",
    LOCAL_STREAM = "localStream",
    REMOTE_STREAM = "remoteStream",
    MUTE = "mute",
}